// This script fixes the warning:
// Warning: "Blocked aria-hidden on an element because its descendant retained focus" when a modal is closed.
// See: https://github.com/twbs/bootstrap/issues/41005
import { isHTMLElement } from "~/types/types.util"

window.addEventListener("hide.bs.modal", () => {
  const target = document.activeElement
  if (target && isHTMLElement(target)) target.blur()
})
